<template>
  <div class="p-4">
    <!--        <ads-selector></ads-selector>-->
    <div class="p-0 mt-5 pt-5" style="border: none!important;">
      <category-selector
          @category-current="getCurrent" ref="category"
          :multiAdsCat="false"></category-selector>
      <div class="col-md-8 mx-auto py-0 my-0">
        <city-selector :auto_change="auto_changes" class="py-0"
                       ref="city" :force="true"
                       :MultiCity="true"></city-selector>
        <div v-for="(item,index) in properties">
          <component :key="item.name"
                     :is="item.has_fields ? 'InDialogRangeField' : item.component"
                     :fields="item.has_fields"
                     :label="item.label"
                     item-value="key"
                     @input="getValues($event,item.name,item.Fielad_type)"
                     item-text="lable"
                     :items="item.items"
                     :multiple="item.multi"
                     chips
                     @change="getBooleanValue($event,item.name,item.Fielad_type)"
                     :name="item.name"
                     deletable-chips
                     small-chips
                     :value="item.value"
                     :max="item.counter"
                     :maxLength="item.max"
                     oninput="if(Number(this.value) > Number(this.max) && this.type === 'number') this.value = this.max; else if(Number(this.value) < Number(this.min) && this.type === 'number') this.value = this.min;"
                     :min="item.min"
                     :placeholder="item.placeholder"
                     outlined
                     clear-icon="mdi-close-circle-outline"
                     prepend-inner-icon="fa fa-pencil-alt"
                     clearable
                     dense
                     :type="item.type"
          >
          </component>
        </div>
        <v-text-field v-model="schemas.key_word" outlined dense clear-icon="mdi-close-circle-outline"
                      prepend-inner-icon="fa fa-pencil-alt"
                      clearable name="keyword" label="کلمه کلیدی"
                      hint="دقت کنید : این کلمه در جستجوی دسته ی منتخب فیلتر خواهد شد."></v-text-field>
        <v-btn @click="schemaset" color="warning" class="text-dark"
               v-if="schemas.category !== '' ">
          <span class="material-icons">verified_user</span>
          اعتبارسنجی
        </v-btn>
        <p class="text-center text-danger" v-if="searchResults.length <= 0">برای مشاهده آگهی های مشابه
          موردنظر باید روی دکمه اعتبار سنجی کلیک کنید</p>
      </div>
    </div>

    <v-row class="mt-4" v-if="searchResults.length > 0">
      <v-col class="col-md-4" v-for="(item,index) in searchResults">
        <v-card
            :color="tokens.indexOf(item.token) > -1 ? 'red':'#191179' "
            dark
            class="text-white"
            max-height="300"
            elevation="4"
            :key="item.token"
        >
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-subtitle class="py-2" v-text="item.title"></v-card-subtitle>
              <v-card-subtitle class="py-1" v-text="item.top_description_text"></v-card-subtitle>
              <v-card-subtitle class="py-1" v-text="item.middle_description_text"></v-card-subtitle>
              <v-card-subtitle class="py-1" v-text="item.bottom_description_text"></v-card-subtitle>
            </div>
            <v-avatar
                class="ma-3"
                size="115"
            >
              <v-img
                  :src="item.images.length > 0 && item.images[0] !== null ? item.images[0] : require('@/assets/img/rblandNotext.png')"></v-img>
            </v-avatar>
          </div>
        </v-card>

      </v-col>
      <v-col v-if="failedData === true">
        <v-img
            src="https://cdn.rawgit.com/ahmedhosna95/upload/1731955f/sad404.svg"
            max-height="400"
            max-width="400"
            class="mx-auto"
        >
        </v-img>
        <p class="text-center">نتیجه ای وجود ندارد!</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {Bus} from "@/main";
import CitySelector from "@/view/pages/divar/divarDependency/citySelector";
import InDialogRangeField from "@/view/pages/divar/divarNews/inDialogRangeField";
import Swal from "sweetalert2";
import {VAutocomplete, VHidden, VSelect, VSwitch, VTextarea, VTextField,} from 'vuetify/lib';
import GetPanelsNumber from "@/view/pages/divar/divarDependency/getPanelsNumber";
import categorySelector from "../divarDependency/categorySelector";

export default {
  name: "similarAds",
  components: {GetPanelsNumber, CitySelector, categorySelector, InDialogRangeField},
  props: {
    auto_changes: {
      default: false,
    },
    cats: {
      default: ''
    },
    adv: {
      default: false
    },
    estate: {
      default: false
    },
    taze: {
      default: false
    },
    correctAuth: {
      default: false
    }
  },
  data() {
    return {
      result: [],
      tokens: [],
      searchResults: [],
      current: '',
      minPrice: '',
      schemas: {
        key_word: "",
        "last_post": 0,
        "other_filters": {}
      },
      maxPrice: '',
      translates: [],
      failedData: false,
      properties: [],
      searchFields: [],
      correctAuth: false,
      city: '',
      neighborhood: '',
      inputs: {
        "radio": VSelect,
        "string": VTextField,
        "number": VTextField,
        "hierarchy_widget": VSelect,
        "SingleSelectHierarchyWidget": VSelect,
        "select": VAutocomplete,
        "textarea": VTextarea,
        "boolean": VSwitch,
        "hidden": VHidden,
        "array": VAutocomplete,
        "object": VAutocomplete,
      },
    }
  },
  methods: {
    translator(name) {
      return this.translates[name];
    },
    getAds() {
      const category = this.cats !== '' ? this.translator(this.cats) : this.translator(this.current)
      $.ajax({
        url: `${url}/user/divar/search/fields/${category}`,
        method: "GET",
        fn: this.getAds,
        headers: {
          Authorization: Token,
          ACCEPT: "application/json"
        },
        success: (res) => {
          this.searchFields = res.data
        }
      })
      ;
    },
    getNewCategories() {
      if (localStorage.getItem('searchCategory')) {
        this.translates = JSON.parse(localStorage.getItem('searchCategory'));
        return;
      }
      $.ajax({
        url: `${url}/user/divar/search/category`,
        type: "GET",
        fn: this.getNewCategories,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        success: (data) => {
          this.translates = data.data
          localStorage.setItem('searchCategory', JSON.stringify(data.data))
        }
      })
    },
    getTokens() {
      $.ajax({
        url: `${url}/advertise/tokens`,
        type: "GET",
        fn: this.getNewCategories,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        success: (data) => {
          this.tokens = data.data
        }
      })
    },
    getCurrent: function (value) {
      this.current = value;
    },
    getProperty(key) {
      const name = key.name;
      const min = key.min;
      const max = key.max;
      const help = key.placeholder;
      const requireField = key.required;
      const placeholder = 'جستجوی ' + key.label + ' ' + 'موردنظر';
      const autoReload = key.auto_refresh
      const field_type = key.field_type
      const has_field = key.fields
      const multi = key.type === "InDialogMultiSelectField" || key.type === "CustomFilterNestedMultiSelectField" ? true : false;
      let items = [];
      let type = key.field_type !== null ? key.field_type : (key.field_type !== 'integer' ? key.field_type : "number");
      let title = key.label;
      let itemValue = key.enum ?? [];
      let itemText = key.enumNames ?? itemValue;
      if (title === "آگهی‌دهنده" || title === "نوع آگهی‌دهنده ") {
        itemText.push("همه");
        itemValue.push(null);
      }
      itemValue.forEach((item, index) => {


        items.push({
          key: item,
          lable: itemText[index]
        })
      })

      return {
        component: this.inputs[type],
        label: title,
        counter: max ? max : null,
        hint: help ? help : null,
        items: items,
        name: name,
        min: min,
        value: "",
        required: requireField,
        placeholder: placeholder,
        errorMessage: "",
        autoReload: autoReload,
        type: type,
        has_fields: has_field,
        multi: multi,
        Fielad_type: field_type
      };
    },
    getValues(esm, name, field) {
      this.searchResults = []
      if (field === "object") {
        this.schemas.other_filters[name] = {
          "value": esm
        };
      } else
        this.schemas.other_filters[name] = esm !== null ? {"value": esm} : [];
    },
    getBooleanValue(val, name, field) {
      this.searchResults = []
      if (field === "boolean") {
        this.schemas.other_filters[name] = val;
      } else
        return;
    },
    schemaset() {
      const data = this.schemas

      if (this.city === '') {
        this.$nextTick(function () {
          this.$modal.error('خطا!', 'شما برای اعتبار سنجی نیاز به انتخاب شهر دارید.')
        })
        return;
      }

      $.ajax({
        url: `${url}/user/divar/search`,
        method: "POST",
        fn: this.schemaset,
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token,
          "Content-Type": "application/json"
        },
        data: JSON.stringify(data),
        success: (res) => {
          if (res.data.length === 0) {
            this.searchResults = []
            this.failedData = true;
            this.correctAuth = false;
            Swal.fire({
              title: 'اعتبار سنجی با شکست مواجه شد! لطفا فیلدهای ورودی را چک کنید.',
              icon: 'error',
            });
          } else {
            this.searchResults = []
            this.correctAuth = true
            this.searchResults = res.data
            this.failedData = false;

          }
        },

      })
    }
  },
  watch: {
    searchFields() {
      this.properties = [];

      const filtered = this.searchFields.filter((x) => x.type !== "hidden" && (x.name !== 'category' && x.name !== 'districts' && x.name !== 'divider'))

      filtered.forEach((item) => {
        this.properties.push(this.getProperty(item));
      });
    },
    correctAuth: {
        handler: (value) => {
            Bus.$emit('correctAuth', value);
      },
      deep: true
    },
    schemas: {
      deep: true,
      handler(val) {
          Bus.$emit('getSimilarData', val);
      }
    },
    city() {
      Bus.$emit('getSimilarData', this.schemas);
      this.searchResults = []
    },
    searchResults() {
      Bus.$emit('Authenticate', this.searchResults);
    },
    current() {
        this.searchResults = [];
      this.correctAuth = false
    }
  },
  mounted() {
    this.getNewCategories();
    // this.getTokens()
    Bus.$on('category-current', (current) => {
      this.current = current;
      this.schemas["category"] = Bus.getProp('category_current')
      this.getAds();
    });

    Bus.$on('dialogRange', (name, value = null) => {
      this.schemas.other_filters[name] = value;
      if (value != null) {
        this.searchResults = []
      }
    });

    Bus.$on('cityInfo', (value) => {
      if (value.city !== undefined) {
        this.city = value.city
      }
      this.schemas["cities"] = [
        value.city + ''
      ];

      if (value.neighborhood !== undefined) {
        this.searchResults = [];
        this.neighborhood = String(value.neighborhood)
        this.schemas.other_filters["districts"] = {
          "vacancies": String(value.neighborhood).split(',')
        }
      }

      if (value.neighborhood.length === 0)
        delete this.schemas.other_filters["districts"];
    })
  }

}
</script>

<style>
.fa-pencil-alt {
  font-size: 12.5pt !important;
}
</style>